module.exports = __webpack_public_path__ + "static/media/pacific.04a618f9.jpg";